export default __webpack_public_path__ + "static/media/back-disabled.86c5168b.png";